<template>
  <div
    class="lg:px-20 md:px-12 px-5 lg:py-16 md:py-16 py-10 bg-primary testimonials test hide"
  >
    <el-dialog :visible.sync="dialogVisible" width="40%">
      <div class="flex justify-between relative break-normal">
        <div class="flex gap-2">
          <img
          :src="`${$imageURL}/${dialogboxdata.image}`"
          alt="user"
          class="md:h-28 lg:h-28 h-16 md:w-28 lg:w-28 w-16 rounded-full"
        />
        <div class="mx-2 my-auto">
          <p class="font-medium text-lg md:text-2xl text-black">{{dialogboxdata.name}}</p>
          <p class="clr777 font-normal lg:text-lg text-sm">
            {{dialogboxdata.description}}
          </p>
        </div>
        </div>
        <img
        src="../../../assets/images/cross.png"
        class="h-8 w-8 cursor-pointer"
        alt="cross"
       @click="dialogVisible = false"
      />
      </div>
    </el-dialog>
    <Testimonialspopup1
      :isActive="isLeaveActive"
      :selectTesimonial="selectTesimonial"
      @close="handlePopup"
    />
    <div class="text-center container mx-auto lg:pb-12 md:pb-10 pb-5">
      <h2 class="fsize30 sm-fsize24 font-semibold clr-fff">
        What our partnered companies say about Caregiver Saathi
      </h2>
    </div>
    <swiper :options="swiperOption" class="mySwiper">
      <swiper-slide
        class="p-4 bg-white rounded-xl bdr-black"
        :key="index"
        v-for="(item, index) in ffc_all_testimonial.result"
      >
        <div class="lg:mb-6 md:mb-6 mb-4 h-40" @click="DialogOpenBox(item)">
          <!-- <img
            class="mb-4 w-10 h-10"
            :src="`${$imageURL}/${item.image}`"
            alt="img"
          /> -->
          <p class="clr-black sm-fsize14 lineclamp-6">
            {{ item.description }}
          </p>
        </div>
        <div class="flex justify-between items-center">
          <div>
            <p class="font-semibold clr-black">
              {{ item.isHidden ? "Anonymous" : item.name }}
            </p>
            <p class="sm-fsize14">
              {{ item.isHidden ? "-" : item.profession }}
            </p>
          </div>
          <div>
            <img
              class="w-12 h-12 rounded-full object-cover"
              :src="`${$imageURL}/${item.image}`"
              alt="img"
            />
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
    <div class="mt-4 flex justify-center">
      <button
        class="rounded-full py-2 px-4 clr-fff bdr-fff sm-fsize14"
        @click="handlePopup()"
      >
        Leave a Testimonial
      </button>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
import Testimonialspopup1 from "../../home/components/Testimonialspopup1.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      dialogVisible: false,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        breakpoints: {
          1600: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        observer: true,
        observeParents: true,
      },

      openAddBannerSidebar: false,

      isLeaveActive: false,
      selectTesimonial: {},
      dialogboxdata:""
    };
  },
  components: {
    swiper,
    swiperSlide,
    Testimonialspopup1,
  },
  methods: {
    handlePopup() {
      this.isLeaveActive = true;
    },
    DialogOpenBox(item)
    {
      this.dialogVisible = true;
      this.dialogboxdata = item
    }
  },
  computed: {
    ...mapState("ffc", { ffc_all_testimonial: "ffc_all_testimonial" }),
  },
};
</script>
<style>
.test .el-dialog{
  border-radius: 10px;
}
.hide .el-dialog__header{
  display: none;
}
.testimonials .swiper-button-next {
  border-radius: 100% !important;
  background-size: 57px !important;
  width: 36px !important;
  height: 27px !important;
  background-size: 57px 52px !important;

  background-repeat: no-repeat !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-pack: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}
.testimonials .swiper-button-prev {
  border-radius: 100% !important;
  background-size: 57px !important;
  width: 36px !important;
  height: 27px !important;
  background-size: 57px 52px !important;

  background-repeat: no-repeat !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-pack: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
  font-size: 18px !important;
}
</style>
